<template>
  <el-card class="m-b" v-if="hasChildata">
    <div slot="header" class="clearfix">
      <span class="saas-card-header-name">子订单信息</span>
    </div>
    <zl-server-page-table
      :border="false"
      showTotal
      ref="multipleTable"
      :api="getApi"
      height="400px"
      :columns="columns"
    >
      <!-- template里面写的话会放到columns之后去渲染 -->
      <el-table-column fixed="right" label="操作" min-width="135">
        <template slot-scope="scope">
          <el-link type="primary" @click="selectSubDetail('check',scope.row)">
            查看
          </el-link>
          <template v-if="system === 'purchaser'">
            <template v-if="scope.row.status === 1000">
              <el-divider direction="vertical"></el-divider>
              <el-link type="primary" @click="selectSubDetail('accept', scope.row)">
                验收
              </el-link>
            </template>
            <template v-if="scope.row.status === 1001 && !scope.row.settled">
              <el-divider direction="vertical"></el-divider>
              <el-link type="primary" @click="selectSubDetail('return', scope.row)">
                退换货
              </el-link>
            </template>
          </template>
        </template>
      </el-table-column>
    </zl-server-page-table>
  </el-card>
</template>
<script>
import store from '@/store'
import dayjs from 'dayjs'
import { getValue } from '@/lib/enum'
export default {
  data() {
    return {
      system: this.$store.state.system, // 当前登录的是哪个系统
      columns: [
        {
          label: '序号',
          prop: 'rowNum',
          width: '100px',
          align: 'center'
        },
        {
          label: '子订单编号',
          prop: 'subOrderCode',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '发布时间',
          prop: 'createTime',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => row.createTime && dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss')
        },
        {
          label: '状态',
          prop: 'status',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => getValue('subOrderStatus', row.status)
        }
      ],
      hasChildata: true
    }
  },
  methods: {
    getApi(args) {
      return store.dispatch(`${this.system === 'purchaser' ? 'pageCgrSubOrder' : 'pageGysSubOrder'}`, {
        orderId: this.$route.query.id,
        pageNum: args.page,
        pageSize: args.size
      }).then(res => {
        // 用于父组件子订单信息是否显示，么有就不显示
        this.hasChildata = res.list && res.list.length
        return {
          rows:
            // 后端可能返回null
            (res.list || []).map((t, index) => ({
              ...t,
              // 后端不提供行号,此处手动计算
              rowNum: args.size * (args.page - 1) + index + 1
            })) || [],
          total: res.totalCount
        }
      })
    },
    // 查看子订单页面
    selectSubDetail(val, row) {
      this.$router.push({
        name: `${this.$store.state.system === 'purchaser' ? 'SubOrderCheck' : 'SupplierSubOrderCheck'}`,
        query: {
          id: row.id,
          type: val
        }
      })
    }
  }
}
</script>
